import type { FC } from "react";
import React from "react";
import { UploadPhotoComponent } from "@fas/cpa-cabinet-ui";
import { withStyles } from "@mui/styles";
import { withFormField } from "@fas/ui-core";
import { useDispatch } from "react-redux";
import { addNotification } from "@fas/ui-framework";
import { uploadPhotoStyles } from "../../styles";

const StyledUploader = withStyles(uploadPhotoStyles)(UploadPhotoComponent);

type Props = {
  name: string;
  value?: string | null | File;
  onChange?: (arg0: any) => any;
  disabled?: boolean;
};

const defaultChange: (arg0: any) => any = (e) => e;

const UploadPhoto: FC<Props> = ({
  name,
  value = null,
  onChange = defaultChange,
  disabled,
}) => {
  const dispatch = useDispatch();
  return (
    <StyledUploader
      data-testid={`upload-photo-${name}`}
      value={value}
      disabled={disabled}
      onChange={onChange}
      onError={(): any =>
        dispatch(
          addNotification({
            severity: "error",
            message:
              "Photo upload failed. Your photo must be no larger than 3 MB and be in .png, .jpg or .gif format",
          })
        )
      }
      accept="image/png, image/jpeg, image/gif"
      maxSize={3}
    />
  );
};

export default withFormField(UploadPhoto);
